import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-04/lesson-16/task-03";
import config from "appConfig";

const task: Slide = {
  titleHtml:
    "An omnidirectional condenser microphone has the following characteristics:<br>bias voltage: 150 V, diaphragm stiffness: 145 385 m∙N-1, inter-electrode distance:<br>13 micrometers. What is the diameter of this microphone in inches?<br>Use 1 inch = 2.54 cm.",
  description: "Fill in the value.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [4, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/16/task/task-3.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task03.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
